import type { ReactNode } from "react";
import { WorkspaceCanvas } from "@/components/workspaces/workspace-canvas";
import { WorkspaceMissionTopBar } from "@/components/workspaces/workspace-mission-topbar";
import { WorkspaceTabRail } from "@/components/workspaces/workspace-tab-rail";

export function GovernanceWorkspaceShell({ children }: { children: ReactNode }) {
  return (
    <WorkspaceCanvas
      topbar={<WorkspaceMissionTopBar activeNamespaceId="governance" />}
      workspaceTopbar={<WorkspaceTabRail activeId="governance" />}
      contentProps={{ className: "flex-1 min-h-0" }}
    >
      <div
        id="workspace-panel-governance"
        role="tabpanel"
        aria-labelledby="workspace-tab-governance"
        className="flex min-h-0 w-full flex-1 flex-col"
      >
        {children}
      </div>
    </WorkspaceCanvas>
  );
}
